module.exports = __webpack_public_path__ + "static/media/logo.55cd5fe1.png";